import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment'
import { MenuItem } from '@share';
const apiurl = environment.apiUrl;
@Injectable({
    providedIn: 'root',
})
export class AppMenuService {
    private http = inject(HttpClient);

    getMenu(): Observable<MenuItem[]> {
        return this.http.get<any>(`${apiurl}/menu`).pipe(
            tap((response) => {
                //console.log(response)
            }),
            map((resopnse) => resopnse.menu)
        );
    }
} 